import { useLocation } from 'react-router-dom';

import { PageViewedTracker, useClickstream } from '@zenbusiness/application-commons-clickstream';
import { useCaptureException, ZBError } from '@zenbusiness/application-commons-logging';

import * as ROUTES from '#client/constants/routes';
import { getAppOrigin } from '#client/utils/getAppOrigin';
import { getAppSection } from '#client/utils/getAppSection';

export default function TrackView() {
  const { pathname } = useLocation();
  const captureException = useCaptureException();
  let isInitialized = false;

  try {
    // v5.x requires explicit error handling for useClickstream usage
    const clickstream = useClickstream();
    isInitialized = clickstream.ready;
  } catch (error) {
    // Gracefully handle any clickstream initialization errors
    const zbError = new ZBError(error, {
      level: 'warning'

    });
    captureException(zbError, {
      tags: {
        context: 'TrackView',
        operation: 'track_view_initialization_check'
      }
    });
    isInitialized = false;
  }

  if (!isInitialized || !pathname || pathname === ROUTES.callback) {
    return null;
  }

  const appSection = getAppSection(pathname);

  return (
    <PageViewedTracker
      appOrigin={getAppOrigin(pathname)}
      appSection={appSection}
      experienceOrigin="dashboard"
      // !Note: Do not remove the "key" prop. The key prop is used to force the component to re-render when the pathname changes allowing the track event to be fire on each page load.
      key={pathname}
    />
  );
}
